'use strict';

var runtime = require('../declaration/runtime.cjs');
var buildtime = require('../declaration/buildtime.cjs');

const getInitialEnvValue = (envKeys) => envKeys.reduce(
  (acc, cur) => ({ ...acc, [cur]: "" }),
  {}
);
const runtimeEnvInitialValue = getInitialEnvValue(runtime.runtimeEnvKeys);
const buildtimeEnvInitialValue = getInitialEnvValue(buildtime.buildtimeEnvKeys);

exports.buildtimeEnvInitialValue = buildtimeEnvInitialValue;
exports.runtimeEnvInitialValue = runtimeEnvInitialValue;
//# sourceMappingURL=initialValue.cjs.map
